import { Injectable } from '@angular/core';
import { Anomaly } from '@fullyops/data/anomalies/anomaly';
import { ApiAnomaliesAdapterService } from '@fullyops/data/anomalies/api-adapter.service';
import { createStore } from '@ngneat/elf';
import {
  addEntities,
  deleteAllEntities,
  selectAllEntities,
  setEntities,
  withEntities,
} from '@ngneat/elf-entities';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AnomaliesService {
  constructor(private api: ApiAnomaliesAdapterService) {}

  private store = createStore(
    { name: 'anomalies' },
    withEntities<Anomaly>({ idKey: 'id' }),
  );

  anomalies$ = this.store.pipe(selectAllEntities());

  refresh(): void {
    this.api.getAll().subscribe((res) => this.store.update(setEntities(res)));
  }

  create(description: string): Observable<string> {
    const sub = new Subject<string>();
    this.api.create(description).subscribe(sub);
    sub.subscribe((anomalyId) =>
      this.store.update(addEntities({ id: anomalyId, description })),
    );
    return sub;
  }

  clear() {
    this.store.update(deleteAllEntities());
  }
}
